<template>
    <v-dialog
        persistent
        fullscreen
        :scrim="false"
        :z-index="10000"
        transition="fade-transition"
        content-class="global-v-dialogue"
        v-model="openState"
    >
        <div :class="['global-action-prompt create-item__prompt ', (openState) ? 'show-prompt' : '']">
            <div class="elevation-4 prompt__message">
                <div class="message__inner">
                    <h4>{{actionTitle}}</h4>
                    <p>{{actionDescription}}</p>
                    <div class="message__actions">
                        <v-btn
                                variant="outlined"
                                @click="clickYes">YES</v-btn>
                        <v-btn
                                color="primary"
                                variant="flat"
                                class="text-white"
                                @click="clickNo">NO</v-btn>
                    </div>

                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import {
        VUEX_GLOBAL_ACTION_PROMPT_YES,
        VUEX_GLOBAL_ACTION_PROMPT_NO
    } from '@/store/constants/global_action_prompt'
    export default {
        name: "global-action-prompt",
        computed: {
            ...mapState({
                openState: state => state.global_action_prompt.show,
                actionTitle: state => state.global_action_prompt.actionObj.title,
                actionDescription: state => state.global_action_prompt.actionObj.description,
            }),
        },
        methods: {
            ...mapActions({
                clickYes: VUEX_GLOBAL_ACTION_PROMPT_YES,
                clickNo: VUEX_GLOBAL_ACTION_PROMPT_NO,
            }),
        },
    }
</script>